import { createSlice } from "@reduxjs/toolkit";
import { uniqueId } from "lodash";
import { AlertProps } from "react-bootstrap";

const generateToast = (
  variant: AlertProps["variant"],
  message: string,
  tag?: string
): Toast => ({
  id: uniqueId(),
  message,
  variant,
  tag,
});

type Toast = {
  id: string;
  message: string;
  variant: AlertProps["variant"];
  tag?: string;
};

type InitialState = {
  queue: Toast[];
};

const initialState: InitialState = {
  queue: [],
};

const toasterSlice = createSlice({
  name: "toasterSlice",
  initialState,
  reducers: {
    show: (state, action) => {
      const variant = action.payload.variant;
      const message = action.payload.message;
      const tag = action.payload.tag;

      const isDuplicate = state.queue.some(
        (record) => record.message === message
      );

      if (variant && message && !isDuplicate) {
        const toast = generateToast(variant, message, tag);

        state.queue.push(toast);
      }
    },
    hide: (state, action) => {
      const index = state.queue.findIndex(
        (toast) => toast.id === action.payload
      );

      state.queue.splice(index, 1);
    },
    hideAll: (state) => {
      state.queue = [];
    },
    reset: () => initialState,
  },
});

const show = (variant: AlertProps["variant"], message: string, tag?: string) =>
  toasterSlice.actions.show({
    variant,
    message,
    tag,
  });

const showSuccess = (message: string, tag?: string) =>
  show("success", message, tag);
const showError = (message: string, tag?: string) =>
  show("danger", message, tag);
const showWarning = (message: string, tag?: string) =>
  show("warning", message, tag);
const showInfo = (message: string, tag?: string) => show("info", message, tag);

export { toasterSlice, showSuccess, showError, showWarning, showInfo };
